<template>
    <div>
        <div class="row">
            <div class="column small-9">
                <PageTitle title="Bericht sturen" :total="total" :loading="loading" />
            </div>
            <div class="column small-3 text-right">
                <b-button type="is-dark" tag="router-link" :to="{ name: 'MailRecord', params: {id: 'nieuw'} }" v-if="allowCreating">Nieuw</b-button>
            </div>
        </div>

        <div class="row">
            <div class="column">
                <b-table
                    :data="records"
                    :striped="true"
                    :loading="loading"
                    :mobile-cards="true"

                    backend-pagination
                    :total="total"
                    :per-page="perPage"
                    @page-change="onPageChange"
                    backend-sorting
                    :default-sort-direction="sortOrder"
                    :default-sort="[sortField, sortOrder]"
                    @sort="onSort"

                    :paginated="paginated"
                    :sort-icon="'chevron-up'"
                >
                    <template>
                        <b-table-column v-slot="props" field="organisation" label="Org." width="50" :visible="user && user.role == 'pit' && $store.state.dataBelongsTo === 'all'" class="admin">
                            <strong v-if="props.row.organisation && user && user.role == 'pit'">
                                {{ organisations[props.row.organisation].short_name }}
                            </strong>
                            <span v-else>Basis</span>
                        </b-table-column>

                        <b-table-column v-slot="props" field="subject" label="Onderwerp" width="300" sortable>
                            {{ props.row.subject.length > 32 ? props.row.subject.substring(0,32) + '...' : props.row.subject }}
                        </b-table-column>

                        <b-table-column v-slot="props" field="type" label="Soort" width="150" sortable>
                            {{ parseTypeName(props.row.type) }}
                        </b-table-column>

                        <b-table-column v-slot="props" field="receivers" label="Ontvanger(s)" number sortable>
                            <b-button tag="router-link" type="is-text" size="is-small" v-if="_.has(props, 'row.customer')" class="text-left" :to="{ name: 'CustomersRecord', params: {id: props.row.customer.id} }">
                                <span v-if="hideSensitiveData">********</span>
                                <span v-else>
                                    <span v-if="(props.row.customer.firstname + ' ' + props.row.customer.lastname).length > 18">
                                        {{ (props.row.customer.firstname + ' ' + props.row.customer.lastname)|truncate(20, '..') }}
                                    </span>
                                    <span v-else>
                                        {{ props.row.customer.firstname + ' ' + props.row.customer.lastname }}
                                    </span>
                                    <span v-if="!_.isNull(props.row.customer.companyname) && (props.row.customer.type == 'business' || props.row.customer.type == 'foundation')" :icon="!_.isNull(props.row.customer.companyname) && (props.row.customer.type == 'business' || props.row.customer.type == 'foundation') ? 'building' : 'people'">
                                        <br>
                                        <strong>
                                            <span v-if="props.row.customer.companyname.length >= 20">
                                                <b-tooltip :label="props.row.customer.companyname" position="is-top">
                                                    {{ props.row.customer.companyname|truncate(18, '..') }}
                                                </b-tooltip>
                                            </span>
                                            <span v-else>{{ props.row.customer.companyname }}</span>
                                        </strong>
                                    </span>
                                </span>
                            </b-button>
                            <b-button tag="router-link" type="is-text" size="is-small" v-else :to="{ name: 'MailRecord', params: {id: props.row.id}, query: { 'receivers': 1 }}">
                                {{ props.row.receivers }} ontvangers
                            </b-button>
                        </b-table-column>

                        <b-table-column v-slot="props" label="Aangemaakt" width="200">
                            <span v-if="props.row.user">{{ props.row.user.name }}<span v-if="user.role == 'pit'">{{ props.row.user.role == 'pit' ? ' (PIT)' : ' ('+props.row.user.organisation.name+')' }}</span></span>
                        </b-table-column>

                        <b-table-column v-slot="props" field="send_date" label="Verzenddatum" width="180" sortable>
                            {{ props.row.send_date|humanDateTime }}

                        </b-table-column>

                        <b-table-column v-slot="props" numeric width="100">
                            <b-button tag="router-link" type="is-dark" size="is-small" :to="{ name: 'MailRecord', params: { id: props.row.id }}">Bekijken</b-button>
                        </b-table-column>
                    </template>

                    <template #empty>
                        <section class="section">
                            <div class="content has-text-grey has-text-centered">
                                <p class="margin0" v-if="loading === false">{{ env == 'demo' ? 'Massa mail niet beschikbaar in de demo.' : 'Geen massa mails gevonden.' }}</p>
                                <p class="margin0" v-else>Laden...</p>
                            </div>
                        </section>
                    </template>
                </b-table>
            </div>
        </div>
    </div>
</template>

<script>
import filtersMixin from '@/mixins/filterMixins'
import paramsMixin from '@/mixins/paramsMixin'

export default {
    name: 'MailOverview',

    mixins: [filtersMixin, paramsMixin],

    data() {
        return {
            loading: false,
            records: [],
            total: null,
            sortField: 'created_at',
            sortOrder: 'desc',
            defaultSortOrder: 'desc',
            page: 1,
            perPage: 20,
            searchParams: _.has(this.$store.state.searchQueries, 'MailOverview') ? this.$store.state.searchQueries['MailOverview'] : null
        }
    },

    computed: {
        paginated() {
            return this.records && this.records.length < this.total
        },

        user(){
            return this.$store.state.user
        },

        organisations() {
            return this.user.role === 'pit' ? this.$store.state.organisations : this.user.organisations
        },

        allowCreating() {
            let allowCreating = false

            if(_.has(this.user.organisation_settings, 'strictmassamail') && this.user.organisation_settings.strictmassamail == 1 && (this.user.role == 'pit' || this.user.is_admin)){
                allowCreating = true
            } else if(!_.has(this.user.organisation, 'strictmassamail') || this.user.organisation.strictmassamail == 0){
                allowCreating = true
            }

            if(this.user.role == 'pit'){
                allowCreating = true
            }

            return allowCreating
        },

        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        },

        env() {
            return this.$store.state.env
        }
    },

    created() {
        this.load()
    },

    methods: {
        load(){
            this.getSearchParams().then(() => {
                this.loadAsyncData()
            })
        },

        loadAsyncData() {
            // Set filter params & admin params
            const params = this.setParams(this.searchParams, 'MailOverview')

            this.loading = true

            axios.get(`/api/mail${params ? '?'+params : ''}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.records = []

                this.total = response.data.total
                this.page = response.data.current_page
                this.records = response.data.data

                this.$store.dispatch('setSearchQuery', {type: 'MailOverview', query: params})
            }).catch((error) => {
                console.error('[❌] Error while fetching massmails:', error)
                this.total = null
            }).then(() => {
                this.loading = false
                // this.searchParams = null
            })
        },

        parseTypeName(type) {
            let term

            switch(type) {
                case 'test':
                    term = 'Test e-mail'
                break;
                case 'specific_customer':
                    term = 'Klant specifiek'
                break;
                case 'all_organisation_users':
                    term = 'Alle gebruikers in organisatie'
                break;
                case 'all_customers':
                    term = 'Alle klanten'
                break;
                case 'all_customers_contracts':
                    term = 'Klanten met actief contract'
                break;
                case 'invoiced_previous_month':
                    term = 'Vorige maand gefactureerd'
                break;
                case 'invoiced_this_month':
                    term = 'Deze maand gefactureerd'
                break;
                default:
                    if (type.startsWith('pricechange_')) {
                        term = 'Prijswijziging'
                    } else {
                        term = 'Onbekend'
                    }
                break;
            }

            return term
        },

        onSort(field, order) {
            this.sortField = field
            this.sortOrder = order
            this.load()
        },

        onPageChange(page) {
            this.page = page
            this.loadAsyncData()
        },
    }
}
</script>
